import React from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import { BrowserTracing } from '@sentry/tracing';
import { Breadcrumb } from '@sentry/react';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  release: process.env.REACT_APP_VERSION,

  replaysSessionSampleRate: 1.0, //TODO change to 10% once production ready
  replaysOnErrorSampleRate: 1.0,

  tracesSampler: () => {
    if (process.env.REACT_APP_SENTRY_ENV === 'production') return 0.2;

    return 0.5;
  },

  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
      // TODO add backend, once deployed
      // see https://docs.sentry.io/platforms/javascript/guides/react/performance/instrumentation/automatic-instrumentation/
      tracePropagationTargets: [
        'localhost:3006',
        /^https:\/\/api\.example\.com/,
        /^\//,
      ],
    }),

    // this integration enables us to extract axios error data and log it
    new ExtraErrorDataIntegration(),

    new Sentry.Replay({
      maskAllText: false,
    }),
  ],

  beforeSend(event) {
    //If we want the user to submit an error report
    // if (event.exception) {
    //   Sentry.showReportDialog({ eventId: event.event_id });
    // }
    // todo check later if necessary?

    // if (event.user) {
    //   delete event.user.email;
    // }

    return event;
  },
});

function logBreadcrumb({ category, message, level, type }: Breadcrumb): void {
  Sentry.addBreadcrumb({
    category,
    message,
    level,
    type,
  });
}

type LogExceptionType = {
  error: any;
  message?: string;
  errorData?: any;
};

function logException({ error, message, errorData }: LogExceptionType): void {
  if (message) {
    logBreadcrumb({
      type: 'error',
      category: 'error',
      level: 'error',
      message,
    });
  }

  const scope = new Sentry.Scope();
  if (errorData) {
    scope.setContext('errorData', errorData);
  }
  Sentry.captureException(error, scope);
}

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export { logBreadcrumb, logException, sentryCreateBrowserRouter };
